// Google Maps API configuration
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

export const defaultMapCenter = {
  lat: 32.7157, // San Diego
  lng: -117.1611
};

export const defaultMapZoom = 10;

